import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppSelector } from 'utils/hooks';

import Link from 'components/shared/Link';

import activeEditor from 'domains/active_editor';

function ChangeCatalogButton({ linkText = 'Change Product Line' }) {
  const catalog = useAppSelector(activeEditor.selectors.catalog);

  const name = catalog ? catalog.name : '';

  return (
    <div className="catalog_navigation_container">
      <div className="catalog-navigation">
        <Link className="change-catalog-button button link" href="/">
          <h1>{name}</h1>
          <span>{linkText}</span>
        </Link>
      </div>
      <div className="mobile-catalog-navigation">
        <Link href="/" a11yText={linkText}>
          <FontAwesomeIcon icon="chevron-left" />
        </Link>
        <h1>{name}</h1>
      </div>
    </div>
  );
}

export default ChangeCatalogButton;
